<div class="modal__header">
  <h1 mat-dialog-title >
    {{data.header}}
  </h1>
  <span class="material-icons" (click)="exitDialog()">close</span>
</div>
<div class="modal__content" mat-dialog-content>
  <form [formGroup]="formOptions" (ngSubmit)="editStatus()" #formDirective="ngForm">
    <div class="row">
      <div class="col-12">
        <mat-form-field>
          <input matInput type="text" formControlName="name" placeholder="Waluta">
          <mat-error *ngIf="formOptions.controls['name'].errors?.required">
            Pole wymagane</mat-error>
        </mat-form-field>
        <mat-checkbox class="example-margin" formControlName="active">Aktywna</mat-checkbox>
      </div>
    </div>
  </form>
</div>
<div class="modal__footer mat_buttons" mat-dialog-actions>
  <button mat-raised-button color="default" (click)="exitDialog()">Zamknij</button>
  <button mat-raised-button type="submit" [disabled]="formOptions.invalid" (click)="formDirective.ngSubmit.emit()"
    color="primary">Zapisz</button>
</div>
